// Vokshus PDP add-ons (rev27) — "Bygg ut settet ditt".
// Additivt tilbehørskjøp ved siden av valgt kit. Rører ALDRI kit-ATC-formen,
// så checkout-flyten er uforandret. Hver "Legg til" gjør et /cart/add.js-kall
// og fyrer Horizons 'cart:update'-event så kurv-ikonet oppdaterer antallet.
//
// • Stegare (brødpose/bivoks): − / + justerer antall, "Legg til N" legger N stk.
// • Toggle (kort uten stegare, f.eks. lineup-kortene): "Legg til" legger 1 stk.
// Ingen rabatt, ingen bundle — prisen kommer fra tilbehørs-varianten selv.

(() => {
  // i18n: locale-flagg + etikett-resolver fra [data-vk-addons] data-attributter
  // (satt via | t i vokshus-addons.liquid). Fallback til norsk literal sa en
  // manglende nokkel aldri kan blokkere «Legg til».
  let VK_ADDON_LOCALE = 'nb';
  const addonLabels = (el) => {
    const root = el && el.closest('[data-vk-addons]');
    const d = (root && root.dataset) || {};
    return {
      add: d.vkLblAdd || 'Legg til',
      addN: d.vkLblAddN || 'Legg til {n} – {price}',
      adding: d.vkLblAdding || 'Legger til…',
      added: d.vkLblAdded || '✓ Lagt til',
      error: d.vkLblError || '✗ Feil — prøv igjen'
    };
  };

  // data-unit-price är alltid besökarens egen valuta (Shopify har redan växlat
  // variantpriset), så här ska inget räknas om — bara rätt symbol sättas.
  // window.VK_MONEY kommer från snippets/vk-money-config.liquid; saknas den
  // skriver vi kronor som förut i stället för att tappa priset helt.
  const kr = (cents) => {
    const n = Math.round(cents) / 100;
    const cfg = window.VK_MONEY;
    // 🔴 2026-08-21: tecknet kom förut ur SPRÅKET, vilket gav «€42.95» på /en-eu
    // medan Liquid skrev «€42,95» på samma sida. Shopify formaterar euron med
    // komma även på en engelsk sida, så tecknet måste komma ur valutan.
    // cfg.dec sätts av snippets/vk-money-config.liquid ur Shopifys egen
    // formatering och är enda sanningen. Fallbacken är den gamla språkregeln.
    const sep = (cfg && cfg.dec) || (VK_ADDON_LOCALE === 'en' ? '.' : ',');
    const num = Number.isInteger(n) ? `${n}` : n.toFixed(2).replace('.', sep);
    // cfg.enhetEfter sätts av snippets/vk-money-config.liquid och är enda
    // sanningen om enheten står före eller efter talet: «£20» men «220 kr».
    if (cfg && cfg.iso && cfg.iso !== 'NOK') {
      return cfg.enhetEfter ? `${num} ${cfg.symbol || ''}`.trim() : `${cfg.symbol || ''}${num}`;
    }
    return `${num} kr`;
  };

  function stepperParts(addBtn) {
    const row = addBtn.closest('.vk-addon');
    const countEl = row ? row.querySelector('[data-vk-addon-count]') : null;
    return { row, countEl };
  }

  function syncStepperButton(addBtn) {
    const { countEl } = stepperParts(addBtn);
    if (!countEl) return;
    const count = parseInt(countEl.textContent, 10) || 0;
    const unit = parseInt(addBtn.dataset.unitPrice, 10) || 0;
    addBtn.disabled = count < 1;
    addBtn.classList.remove('is-added');
    const L = addonLabels(addBtn);
    addBtn.textContent = count < 1 ? L.add : L.addN.replace('{n}', count).replace('{price}', kr(count * unit));
  }

  async function dispatchCartUpdate(scopeEl) {
    try {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      const cart = await res.json();
      (scopeEl || document.body).dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'vokshus-addons',
            data: { source: 'vokshus-addons', itemCount: cart.item_count },
          },
        })
      );
    } catch (err) {
      /* non-fatal — cart-icon just won't refresh until next navigation */
    }
  }

  // --- Express-kasse-vakt -------------------------------------------------
  // Hurtigkjøp (Apple Pay / Klarna-ekspress) går FORBI handlekurven og tar bare
  // med selve kit-et. Når kunden engasjerer tilbehør (stegare > 0 eller tilbehør
  // ligger i kurven) skjuler vi express-knappene og viser en note, så de fullfører
  // via «LEGG I HANDLEKURV» og får alt med.
  let addonIdSet = null;
  function addonVariantIds() {
    if (addonIdSet) return addonIdSet;
    addonIdSet = new Set();
    document.querySelectorAll('[data-vk-addons] [data-vk-addon-add]').forEach((btn) => {
      const id = parseInt(btn.dataset.variantId, 10);
      if (id) addonIdSet.add(id);
      // Mønster-varianter (bivokspapir): alla 4 id:n måste kännas igen i kurven,
      // annars missar express-vakten papir med annat mønster än det förvalda.
      (btn.dataset.vkAddonAltIds || '').split(',').forEach((raw) => {
        const alt = parseInt(raw, 10);
        if (alt) addonIdSet.add(alt);
      });
    });
    return addonIdSet;
  }

  function anyStepperPending() {
    return Array.from(document.querySelectorAll('[data-vk-addons] [data-vk-addon-count]'))
      .some((el) => (parseInt(el.textContent, 10) || 0) > 0);
  }

  let cartHasAddon = false;
  async function refreshCartAddonFlag() {
    try {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      const cart = await res.json();
      const ids = addonVariantIds();
      cartHasAddon = (cart.items || []).some((it) => ids.has(it.variant_id) || ids.has(it.id));
    } catch (err) {
      /* keep previous flag on failure */
    }
  }

  function evaluateExpressLock() {
    const express = document.querySelector('.vk-product__express');
    const note = document.querySelector('[data-vk-express-note]');
    const locked = anyStepperPending() || cartHasAddon;
    if (express) express.hidden = locked;
    if (note) note.hidden = !locked;
  }

  function setupExpressLock() {
    if (!document.querySelector('[data-vk-addons]')) return;
    // Re-sync flag + lock whenever the cart changes (own adds, cart-drawer removes).
    document.addEventListener('cart:update', () => {
      refreshCartAddonFlag().then(evaluateExpressLock);
    });
    // Initial state: cart may already hold tilbehør from an earlier visit.
    refreshCartAddonFlag().then(evaluateExpressLock);
  }

  function init() {
    const vkAddonsRoot = document.querySelector('[data-vk-addons]');
    if (vkAddonsRoot && vkAddonsRoot.dataset.vkLocale) VK_ADDON_LOCALE = vkAddonsRoot.dataset.vkLocale;

    // Mønster-select (bivokspapir): byt add-knappens variant-id när kunden väljer mønster.
    // JS läser dataset.variantId vid KLICK, så detta räcker; utan JS finns raden inte i köpflödet.
    document.body.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-vk-addon-pattern]');
      if (!sel) return;
      const row = sel.closest('.vk-addon');
      const addBtn = row && row.querySelector('[data-vk-addon-add]');
      if (addBtn && sel.value) addBtn.dataset.variantId = sel.value;
    });

    document.body.addEventListener('click', async (e) => {
      // --- stepper − / + ---
      const dec = e.target.closest('[data-vk-addon-dec]');
      const inc = e.target.closest('[data-vk-addon-inc]');
      if (dec || inc) {
        const row = (dec || inc).closest('.vk-addon');
        const countEl = row && row.querySelector('[data-vk-addon-count]');
        const addBtn = row && row.querySelector('[data-vk-addon-add]');
        if (!countEl || !addBtn) return;
        let count = parseInt(countEl.textContent, 10) || 0;
        count = inc ? Math.min(count + 1, 20) : Math.max(count - 1, 0);
        countEl.textContent = String(count);
        syncStepperButton(addBtn);
        evaluateExpressLock();
        return;
      }

      // --- add to cart ---
      const addBtn = e.target.closest('[data-vk-addon-add]');
      if (!addBtn) return;
      e.preventDefault();

      const variantId = parseInt(addBtn.dataset.variantId, 10);
      if (!variantId) return;

      const isStepper = addBtn.hasAttribute('data-vk-addon-stepper');
      let quantity = 1;
      if (isStepper) {
        const { countEl } = stepperParts(addBtn);
        quantity = parseInt(countEl && countEl.textContent, 10) || 0;
        if (quantity < 1) return;
      }

      const restore = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = addonLabels(addBtn).adding;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (!res.ok) throw new Error(`Add failed: ${res.status}`);

        await dispatchCartUpdate(addBtn);

        addBtn.classList.add('is-added');
        addBtn.textContent = addonLabels(addBtn).added;

        if (isStepper) {
          const { countEl } = stepperParts(addBtn);
          if (countEl) countEl.textContent = '0';
        }
        setTimeout(() => {
          if (isStepper) {
            syncStepperButton(addBtn);
          } else {
            addBtn.classList.remove('is-added');
            addBtn.textContent = restore;
            addBtn.disabled = false;
          }
        }, 1800);
      } catch (err) {
        console.error('Vokshus add-on failed:', err);
        addBtn.classList.remove('is-added');
        addBtn.classList.add('is-error');
        addBtn.textContent = addonLabels(addBtn).error;
        setTimeout(() => {
          addBtn.classList.remove('is-error');
          addBtn.textContent = restore;
          addBtn.disabled = false;
        }, 2500);
      }
    });

    setupExpressLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
